module.exports = {"610117001":"鹿苑街道","610117002":"泾渭街道","610117003":"崇皇街道","610117004":"姬家街道","610117101":"通远镇","610117102":"耿镇","610117106":"张卜镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610117.json
// module id = 2578
// module chunks = 0